import { z } from 'zod';
const text = z.string().nullish();
const flag = z.boolean().nullish();
export const userGroupOptionSchema = z.looseObject({
  groupName: z.string(),
  description: z.unknown().optional(),
});
export const userGroupOptionPageSchema = z.looseObject({
  data: z.array(userGroupOptionSchema),
  paginationToken: text,
});

/** `Group` do legado (`contexts/groupContext.tsx:26-34`); o grupo é identificado pelo nome. */
export const userGroupSchema = z.looseObject({
  id: text,
  groupName: z.string(),
  description: z.unknown().optional(),
  precedence: z.number().nullish(),
  creationDate: text,
  lastModifiedDate: text,
  userPoolId: text,
});
export type UserGroup = z.output<typeof userGroupSchema>;

const pageFields = {
  page: z.number().nullish(),
  totalItems: z.number().nullish(),
  totalPages: z.number().nullish(),
  paginationToken: text,
};
export const userGroupPageSchema = z.looseObject({ data: z.array(userGroupSchema), ...pageFields });
export type UserGroupPage = z.output<typeof userGroupPageSchema>;

/** `UserGetDetailResponseModel` (`contexts/userContext.tsx:46-62`), o que a aba Membros lê. */
export const groupMemberSchema = z.looseObject({
  id: z.string(),
  name: text.meta({ pii: 'name' }),
  registrationNumber: text.meta({ pii: 'document' }),
  phoneNumber: text.meta({ pii: 'phone' }),
  email: text.meta({ pii: 'email' }),
  enabled: flag,
  userStatus: text,
  userCreateDate: text,
});
export type GroupMember = z.output<typeof groupMemberSchema>;
export const groupMemberPageSchema = z.looseObject({ data: z.array(groupMemberSchema), ...pageFields });
export type GroupMemberPage = z.output<typeof groupMemberPageSchema>;

/** Corpo do `POST`/`PUT /UserGroup` (`services/group/index.ts:16-20`); no PUT vai o GET inteiro. */
export type UserGroupBody = Record<string, unknown> & {
  readonly groupName: string;
  readonly description: string | null;
  readonly precedence: number | null;
};

/** Query da lista (`groupContext.tsx:139-151`): nesta ordem; ausente não vai. */
export interface UserGroupListParams {
  readonly searchString?: string | undefined;
  readonly page: number;
  readonly size: number;
  readonly paginationToken?: string | null | undefined;
  readonly tenant?: string | undefined;
}

/** Query dos membros (`services/group/index.ts:50-65`). */
export interface GroupMemberListParams {
  readonly page: number;
  readonly size: number;
  readonly nextToken?: string | null | undefined;
  readonly tenant?: string | undefined;
}
